import { Injectable } from '@angular/core';
import { PatientSearchAutocomplete, PatientSearchFilters } from '@app/core/models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '..';
import { clearState, getPatients } from './patient.actions';
import {
  selectPatientsLoading,
  selectPatientsAutocomplete,
  selectPatientsLoaded,
  selectPatientsPetRecord,
  selectPatientStateError,
} from './patient.selectors';

@Injectable()
export class PatientFacade {
  patientsLoaded$ = this.store$.pipe(select(selectPatientsLoaded));
  patientsLoading$ = this.store$.pipe(select(selectPatientsLoading));
  patientsAutocomplete$: Observable<PatientSearchAutocomplete[]> = this.store$.pipe(select(selectPatientsAutocomplete));
  patientsPetRecord$ = this.store$.pipe(select(selectPatientsPetRecord));
  patientStateError$ = this.store$.pipe(select(selectPatientStateError));

  constructor(private readonly store$: Store<AppState>) {}

  getPatients(filters: PatientSearchFilters): void {
    this.store$.dispatch(getPatients({ filters }));
  }

  clearState(): void {
    this.store$.dispatch(clearState());
  }
}
